module.exports = __webpack_public_path__ + "b42fed1125dbc5fbce90f9a931b92890.svg";